import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_PACKAGE } from 'shared/constants/common';
import PackagesItem from './PackagesItem';

export default function Packages({ packagesList = [] }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_PACKAGE}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionLabel label="Package" className="ml-[10px] mt-1" />
      </div>
      {packagesList.map(
        (
          {
            holidayNumber,
            freeChildPlaces,
            comment: inclusions,
            accommodations: accommodationList,
            flights: flightList,
          },
          index,
        ) => (
          <PackagesItem
            key={`${index + 1}`}
            index={index}
            holidayNumber={holidayNumber}
            freeChildPlaces={freeChildPlaces}
            inclusions={inclusions}
            accommodationList={accommodationList}
            flightList={flightList}
          />
        ),
      )}
    </>
  );
}
